import {defineMessages} from 'react-intl';

export default defineMessages({
  GenericFeature: {
    id: 'DisclosureCategory.highlights.description',
    defaultMessage: 'Extra ticket features available',
  },
  Connected: {
    id: 'DisclosureCategory.connected.description',
    defaultMessage: 'Connected seller',
  },
  GenericDisclosures: {
    id: 'DisclosureCategory.generic.description',
    defaultMessage: 'Restrictions or limitations apply',
  },
});
